import React, { FC, memo } from 'react';
import { IncomeStatisticsTable } from './IncomeStatisticsTable';
import { TableFilterContextProvider } from 'features/TableFilter';

export const IncomeStatisticsPage: FC = memo(() => {
  return (
    <TableFilterContextProvider>
      <IncomeStatisticsTable />
    </TableFilterContextProvider>
  );
});
